import { useEffect, useState } from "react";
// import {
//   getDownloadExportFile,
//   fetchBinLocationDetails,
//   binLocationUploadCheck,
//   uploadBinLocData,
// } from "../model/BinLocation";
import {
  DATE_CHECK,
  DATE_REQUIRED,
  FILE_DOWNLOAD_FAILED,
  FILE_DOWNLOAD_SUCCESS,
  NO_DATA,
} from "../model/Strings";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import Logger from "../../../basecomp/base/Logger";
import { DownloadBinBulk, fetchPutPrintNameOptions, fetchSlocOptions, getSampleUploadFile } from "../model/PrintingModel";
import { getDownloadExportFile, getDownloadMaterialExportFile, getDownloadStickerExportFile } from "../model/inventoryModel";

const InventoryVM = () => {
  const { handleToastOpen } = useToast();
 // const [binLocationData, setBinLocationData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [materialStartDate, setMaterialStartDate] = useState("");
  const [materialEndDate, setMaterialEndDate] = useState("");
  const [stickerStartDate, setStickerStartDate] = useState("");
  const [stickerEndDate, setStickerEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [sLocOptions, setSLocOptions] = useState([]);
  const [printedOptions, setPrintedOptions] = useState([]);
  const [putawayOptions, setPutawayOptions] = useState([]);
  const [isPutawayPending,setIsPutawayPending]=useState(false)
    const [materialNo, setMaterialNo] = useState("");
const [printedBy, setPrintedBy] = useState("");
const [putAwayBy, setPutAwayBy] = useState("");

  const [selectedLocations, setSelectedLocations] = useState([]);

  //const [adminBinUploadAccess, setAdminBinUploadAccess] = useState(false);
  //const [selectedFiles, setSelectedFiles] = useState([]);
  const [responseMessage,setResponseMessage]=useState("")
 // const [alertModelOpen, setAlertModelOpen]=useState(false)

  useEffect(() => {
    const fetchSloc = async () => {
          try {
            const response = await fetchSlocOptions();
            setSLocOptions(response.data.options);
          } catch (error) {
            handleToastOpen("error", error.message);
            setSLocOptions([]);
          }
        };
    fetchSloc();
  }, []);

  useEffect(() => {
    const fetchPutPrintNames = async () => {
          try {
            const response = await fetchPutPrintNameOptions();
            // setSLocOptions(response.data.options);
            setPrintedOptions(response.data.printedNames)
            setPutawayOptions(response.data.putAwayNames)
            console.log("logging response in use effect");
            console.log(response);
          } catch (error) {
            handleToastOpen("error", error.message);
            // setSLocOptions([]);
          }
        };
    fetchPutPrintNames();
  }, []);

//   const handleBinLocUploadCheck = async () => {
//     try {
//       const response = await binLocationUploadCheck();
//       if (response.data.includes(31)) {
//         setAdminBinUploadAccess(true);
//       }
//     } catch (error) {
//       Logger.printStackTrace(error);
//     }
//   };
  const handleStartDateChange = (value) => {
    setStartDate(value);
  };

  const handleEndDateChange = (value) => {
    setEndDate(value);
  };
  const handleMaterialStartDateChange = (value) => {
    setMaterialStartDate(value);
  };

  const handleMaterialEndDateChange = (value) => {
    setMaterialEndDate(value);
  };
  const handleStickerStartDateChange = (value) => {
    setStickerStartDate(value);
  };

  const handleStickerEndDateChange = (value) => {
    setStickerEndDate(value);
  };

  let startDateObj = startDate ? new Date(startDate) : null;
  let endDateObj = endDate ? new Date(endDate) : null;

//   const getBinLocationDetails = async () => {
//     setLoading(true);
//     try {
//       if (startDate && isNaN(startDateObj.getTime())) {
//         startDateObj = null;
//       }
//       if (endDate && isNaN(endDateObj.getTime())) {
//         endDateObj = null;
//       }

//       if (!startDateObj && !endDateObj) {
//         const response = await fetchBinLocationDetails(null, null);
//         setBinLocationData(response.data);
//       } else if (startDateObj && endDateObj) {
//         startDateObj.setHours(0, 0, 0, 0);
//         endDateObj.setHours(23, 59, 59, 999);

//         if (startDateObj <= endDateObj) {
//           const response = await fetchBinLocationDetails(
//             startDateObj,
//             endDateObj
//           );
//           setBinLocationData(response.data);
//         } else {
//           handleToastOpen("error", DATE_CHECK);
//         }
//       } else {
//         if (startDateObj || endDateObj) {
//           handleToastOpen("error", DATE_REQUIRED);
//         } else {
//           const response = await fetchBinLocationDetails(null, null);
//           setBinLocationData(response.data);
//         }
//       }
//     } catch (error) {
//       handleToastOpen("error", NO_DATA);
//     } finally {
//       setLoading(false);
//     }
//   };

  const downloadExportAllFile = async () => {
    if((startDateObj && !endDateObj)||(!startDateObj && endDateObj) ){
      handleToastOpen("error","Enter either both date or none")
      return
    }
    
    if(startDateObj>endDateObj){
      handleToastOpen("error","End date should be greater")
      return
    }
    
    if(startDateObj>Date.now() || endDateObj>Date.now()){
      handleToastOpen("error","Date can not be greater than today")
      return
    }
    console.log("loggingn data");
    console.log(selectedLocations);
    setLoading(true);
    try {
      const response = await getDownloadExportFile(startDateObj, endDateObj,selectedLocations);
      const blob = new Blob([response.data]);
      const currentDate = new Date().toLocaleString("sv-SE").replace("T", " ");
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Inventory-Data${currentDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", FILE_DOWNLOAD_SUCCESS);
      window.location.reload()
    } catch (error) {
      console.log("error in file");
      console.log(error.response);
      handleToastOpen("error", FILE_DOWNLOAD_FAILED);
    } finally {
      setLoading(false);
    }
  };
  const downloadMaterialExportAllFile = async () => {
    let startDateObj = materialStartDate ? new Date(materialStartDate) : null;
  let endDateObj = materialEndDate ? new Date(materialEndDate) : null;
    if((startDateObj && !endDateObj)||(!startDateObj && endDateObj) ){
      handleToastOpen("error","Enter either both date or none")
      return
    }
    
    if(startDateObj>endDateObj){
      handleToastOpen("error","End date should be greater")
      return
    }
    
    if(startDateObj>Date.now() || endDateObj>Date.now()){
      handleToastOpen("error","Date can not be greater than today")
      return
    }
    console.log("loggingn data");
    console.log(selectedLocations);
    setLoading(true);
    try {
      const response = await getDownloadMaterialExportFile(startDateObj, endDateObj);
      const blob = new Blob([response.data]);
      const currentDate = new Date().toLocaleString("sv-SE").replace("T", " ");
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `MaterialCountingData${currentDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", FILE_DOWNLOAD_SUCCESS);
      window.location.reload()
    } catch (error) {
      console.log("error in file");
      console.log(error.response);
      handleToastOpen("error", FILE_DOWNLOAD_FAILED);
    } finally {
      setLoading(false);
    }
  };
  const downloadStickerExportAllFile = async () => {
    let startDateObj = stickerStartDate ? new Date(stickerStartDate) : null;
  let endDateObj = stickerEndDate ? new Date(stickerEndDate) : null;

    if((startDateObj && !endDateObj)||(!startDateObj && endDateObj) ){
      handleToastOpen("error","Enter either both date or none")
      return
    }

    if(startDateObj>endDateObj){
      handleToastOpen("error","End date should be greater")
      return
    }
    
    if(startDateObj>Date.now() || endDateObj>Date.now()){
      handleToastOpen("error","Date can not be greater than today")
      return
    }
    console.log("loggingn data");
    console.log(selectedLocations);
    setLoading(true);
    try {
      const response = await getDownloadStickerExportFile(startDateObj, endDateObj,materialNo,printedBy,putAwayBy,isPutawayPending);
      const blob = new Blob([response.data]);
      const currentDate = new Date().toLocaleString("sv-SE").replace("T", " ");
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `StickerPrintingData${currentDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", FILE_DOWNLOAD_SUCCESS);
      window.location.reload()
    } catch (error) {
      // console.log("error in file");
      // console.log(error.message);
      handleToastOpen("error", error.message);
    } finally {
      setLoading(false);
    }
  };

  


 


  return {
    downloadExportAllFile,

    handleStartDateChange,
    handleEndDateChange,
    downloadMaterialExportAllFile,

    handleMaterialStartDateChange,
    handleMaterialEndDateChange,
    downloadStickerExportAllFile,

    handleStickerStartDateChange,
    handleStickerEndDateChange,
    loading,
    setSelectedLocations,
    selectedLocations,
    responseMessage,
    sLocOptions,
    materialNo,
    printedBy,
    putAwayBy,
    setMaterialNo,
    setPrintedBy,
    setPutAwayBy,
    printedOptions,
    putawayOptions,
    isPutawayPending,
    setIsPutawayPending,

  };
};

export default InventoryVM;
